import { Card, CardContent, CardHeader } from '@material-ui/core';

const DashboardDev = () => (
    <Card>
        <CardHeader title="Ride Modes DEV" />
        <CardContent>Click on the Ride Modes tab on the left to modify the DEV environment ride modes configuration.</CardContent>
    </Card>
);

export default DashboardDev;